import { User, ChatMessageType, TimelineItemType, ActivityEventType } from '@wix/answers-api';

export enum UserTimelineType {
	EVENT = 0,
	TYPING = 1,
	REPLY = 9,
	TIMESTAMP = 10,
	EMAIL_FORM = 11,
}

export type ChatTimelineTimestamp = {
	time: string;
	userTimelineType: UserTimelineType.TIMESTAMP;
};

export enum ChatTimelineEventType {
	AGENT_JOINED = 1
}

export type ChatUser = User;

export type RawChatTimelineEvent = {
	user: ChatUser;
	eventType: ActivityEventType;
	creationDate: number;
};

export type ChatTimelineEvent = {
	userTimelineType: UserTimelineType.EVENT;
} & RawChatTimelineEvent;

export type Attachment = {
	name: string;
	url: string;
	sizeBytes: number;
	contentType: string;
};

export type ChatTimelineMessage = {
	groupPosition: ChatGroupPositionType;
} & ChatMessage;

export enum ChatMessageStatus {
	SENDING = 1,
	SUCCESS = 2,
	FAIL = 3
}

export type ChatMessage = {
	userTimelineType: UserTimelineType.REPLY;
	status: ChatMessageStatus;
} & RawChatMessage;

export type RawChatMessage = {
	userId: string;
	text: string;
	chatMessageData?: { attachments: Attachment[] };
	chatMessageType: ChatMessageType;
	creationDate: number;
	timelineItemType: TimelineItemType.CHAT_MESSAGE;
	user: User;
};

export type ChatTyping = {
	user: ChatUser;
	userTimelineType: UserTimelineType.TYPING;
};

export type RawEmailForm = {
	user: ChatUser;
	userTimelineType: UserTimelineType.EMAIL_FORM;
	email?: string;
	creationDate: number;
};

export type ChatEmailForm = {
	groupPosition: ChatGroupPositionType;
} & RawEmailForm;

export type ChatTimelineReply = RawEmailForm | ChatMessage | ChatTimelineEvent;

export type ChatTimelineItem = ChatTimelineMessage | ChatTimelineEvent | ChatTimelineTimestamp
	| ChatTyping | ChatEmailForm;

export enum ChatGroupPositionType {
	FIRST = 1,
	MIDDLE = 2,
	LAST = 3,
	ONLY = 4
}
